module.exports = __webpack_public_path__ + "static/img/tnB_2.b1c4fd7.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/tnB_2.png
// module id = 1286
// module chunks = 1